import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Phone } from 'lucide-react';
import { SERVICES, BRAND } from '../mock';
import { Button } from '../components/ui/button';
import useReveal from '../hooks/useReveal';

export default function Services() {
  useReveal();
  useEffect(() => { document.title = 'Courier Services | Same-Day, Rush, ASAP & After Hours | StreetFleet'; }, []);

  return (
    <>
      <section className="bg-[#4E4E50] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-white">
          <span className="text-[#4FC3E0] font-bold uppercase tracking-wider text-sm">Our Services</span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-2 mb-4">Courier delivery, your way</h1>
          <p className="text-gray-200 text-lg max-w-2xl">Four service tiers built around how urgently you need it there. All backed by insured drivers and real-time dispatch across Toronto and the GTA.</p>
        </div>
      </section>
      <div className="h-1 bg-gradient-to-r from-[#17A2C4] to-[#4FC3E0]" />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-16">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const flip = i % 2 === 1;
            return (
              <div key={s.id} id={s.id} className={`grid lg:grid-cols-2 gap-10 items-center reveal`}>
                <div className={flip ? 'lg:order-2' : ''}>
                  <img src={s.image} alt={`${s.name} courier delivery service`} className="rounded-2xl shadow-xl w-full h-[340px] object-cover" />
                </div>
                <div className={flip ? 'lg:order-1' : ''}>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 rounded-lg bg-[#17A2C4] flex items-center justify-center text-white"><Icon size={24} /></div>
                    <span className="text-xs font-bold text-[#17A2C4] bg-[#17A2C4]/10 px-3 py-1.5 rounded-full">{s.eta}</span>
                  </div>
                  <h2 className="text-3xl font-extrabold text-[#4E4E50] mb-1">{s.name} Delivery</h2>
                  <p className="text-lg font-semibold text-[#17A2C4] mb-3">{s.tagline}</p>
                  <p className="text-gray-600 mb-5">{s.desc}</p>
                  <ul className="space-y-2 mb-6">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-2.5 text-gray-700">
                        <span className="w-5 h-5 rounded-full bg-[#17A2C4]/10 flex items-center justify-center"><Check size={13} className="text-[#17A2C4]" /></span> {f}
                      </li>
                    ))}
                  </ul>
                  <div className="flex flex-wrap gap-3">
                    <Link to="/contact"><Button className="bg-[#17A2C4] hover:bg-[#128aa8] text-white font-bold gap-2">Request this service <ArrowRight size={16} /></Button></Link>
                    <a href={BRAND.phoneHref}><Button variant="outline" className="border-[#4E4E50] text-[#4E4E50] font-bold gap-2"><Phone size={16} /> {BRAND.phone}</Button></a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
